module.exports = [{
      plugin: require('/opt/build/repo/app/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/typography"},
    },{
      plugin: require('/opt/build/repo/app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
